import React from "react";

/**
 * Signature visual element: concentric sound-wave arcs, a direct
 * callback to the arcs inside the "e" of the HearMenders logo.
 * Used to divide sections instead of a generic straight line.
 */
export default function WaveDivider({ flip = false, tone = "teal" }) {
  const stroke = tone === "amber" ? "#E8A33D" : "#2FA5A9";
  return (
    <div className="wave-divider" style={{ transform: flip ? "scaleY(-1)" : "none" }}>
      <svg viewBox="0 0 1400 64" preserveAspectRatio="none" fill="none" aria-hidden="true">
        <path d="M0 32 Q 350 -10 700 32 T 1400 32" stroke={stroke} strokeOpacity="0.18" strokeWidth="2" />
        <path d="M0 40 Q 350 10 700 40 T 1400 40" stroke={stroke} strokeOpacity="0.32" strokeWidth="2" />
        <path d="M0 48 Q 350 28 700 48 T 1400 48" stroke={stroke} strokeOpacity="0.55" strokeWidth="2" />
      </svg>
    </div>
  );
}
